<script setup>

import MedallionLevelsInfo from '@/components/MedallionLevelsInfo.vue';
import { onMounted } from 'vue';

import { useStorage } from '@vueuse/core'

const props = defineProps({
    tag: {
        type: Object,
        required: true,
    },
    size: {
        type: String,
        required: false,
        default: 'md',
    },
    result: {
        type: Object,
        required: false,
        default: null
    }
});

const state = useStorage('state_tag' + props.tag.id, {
    mode: '',
    levels: {
        // "level_4": {
        //     "level": 4,
        //     "difficulty": 4,
        //     "date_display": "",
        //     "date_ago": ""
        // },
    },
    active: true,
    max_level_reached: 0,
    expected_level: props.tag.expected_level,
    reached_expected_level: false
})

state.value.expected_level = props.tag.expected_level;

onMounted(() => {

    if (props.result?.level_reached) {
        //handle level reached
        if (props.result.difficulty > state.value.max_level_reached) {
            state.value.max_level_reached = props.result.difficulty;
        }
        state.value.reached_expected_level = state.value.expected_level <= state.value.max_level_reached;

        state.value.levels['level_' + props.result.difficulty] = {
            level: props.result.difficulty,
            difficulty: props.result.difficulty,
            date: Date.now(),
            date_display: '',
            date_ago: '',
        }
    }
})

</script>

<template>
    <MedallionLevelsInfo :levels-info="state" :size="size"/>
</template>
